import types from './actionTypes';

export const resetState = () => ({
  type: types.RESET_WEEKLY_PUSH_NOTIFICATION_STATE,
});

export const createWeeklyPushNotification = (weeklyPushNotification) => ({
  type: types.CREATE_WEEKLY_PUSH_NOTIFICATION.REQUEST,
  weeklyPushNotification,
});

export const createWeeklyPushNotificationSuccess = (
  weeklyPushNotification,
) => ({
  type: types.CREATE_WEEKLY_PUSH_NOTIFICATION.SUCCESS,
  weeklyPushNotification,
});

export const createWeeklyPushNotificationFailure = (error) => ({
  type: types.CREATE_WEEKLY_PUSH_NOTIFICATION.FAILURE,
  error,
});

export const updateWeeklyPushNotification = (weeklyPushNotification) => ({
  type: types.UPDATE_WEEKLY_PUSH_NOTIFICATION.REQUEST,
  weeklyPushNotification,
});

export const updateWeeklyPushNotificationSuccess = (
  weeklyPushNotification,
) => ({
  type: types.UPDATE_WEEKLY_PUSH_NOTIFICATION.SUCCESS,
  weeklyPushNotification,
});

export const updateWeeklyPushNotificationFailure = (error) => ({
  type: types.UPDATE_WEEKLY_PUSH_NOTIFICATION.FAILURE,
  error,
});

export const fetchWeeklyPushNotifications = (filters = null) => ({
  type: types.FETCH_WEEKLY_PUSH_NOTIFICATIONS.REQUEST,
  filters,
});

export const fetchWeeklyPushNotificationsSuccess = (
  weeklyPushNotifications,
  filters,
) => ({
  type: types.FETCH_WEEKLY_PUSH_NOTIFICATIONS.SUCCESS,
  weeklyPushNotifications,
  filters,
});

export const fetchWeeklyPushNotificationsFailure = (error) => ({
  type: types.FETCH_WEEKLY_PUSH_NOTIFICATIONS.FAILURE,
  error,
});
